const bvReviewsAPIResponse = {
    "Limit": 10,
    "Offset": 0,
    "TotalResults": 187,
    "Locale": "en_US",
    "Results": [
        {
            "Id": "291023512",
            "CID": "c9bb8e8e-6311-5054-929f-fc6533c2e918",
            "SourceClient": "garageclothing",
            "Badges": {
                "verifiedPurchaser": {
                    "ContentType": "REVIEW",
                    "Id": "verifiedPurchaser",
                    "BadgeType": "Custom"
                }
            },
            "BadgesOrder": [
                "verifiedPurchaser"
            ],
            "LastModeratedTime": "2025-05-21T15:15:13.000+00:00",
            "LastModificationTime": "2025-05-21T15:15:13.000+00:00",
            "ProductId": "10009192006G",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "0034x00001mvi4OAAQ",
            "ContentLocale": "en_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit",
                "Quality"
            ],
            "IsRatingsOnly": false,
            "TotalFeedbackCount": 0,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 0,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_17478384S0RxcK7WcX",
            "SubmissionTime": "2025-05-21T14:40:33.000+00:00",
            "ReviewText": "These are so comfy! Love them. They do fit long.",
            "Title": "Great",
            "UserNickname": "Jen1616",
            "SecondaryRatings": {
                "Quality": {
                    "Value": 5,
                    "Id": "Quality",
                    "ValueRange": 5,
                    "MinLabel": null,
                    "ValueLabel": null,
                    "MaxLabel": null,
                    "Label": "Quality of Product",
                    "DisplayType": "NORMAL"
                },
                "HowDoesItFit": {
                    "Value": 4,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "Slightly larger",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "Small",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "ContextDataValues": {
                "height": {
                    "Value": "58",
                    "Id": "height",
                    "ValueLabel": "5'8\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "140lbs",
                    "Id": "weight",
                    "ValueLabel": "140 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Helpfulness": null,
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": true,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": []
        },
        {
            "Id": "290996303",
            "CID": "dbfc473f-c7db-51a6-afe8-80b31c8dadfc",
            "SourceClient": "garageclothing",
            "Badges": {
                "verifiedPurchaser": {
                    "ContentType": "REVIEW",
                    "Id": "verifiedPurchaser",
                    "BadgeType": "Custom"
                }
            },
            "BadgesOrder": [
                "verifiedPurchaser"
            ],
            "LastModeratedTime": "2025-05-21T04:00:04.000+00:00",
            "LastModificationTime": "2025-05-21T04:00:04.000+00:00",
            "ProductId": "10009192006G",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "0034x00001zCBvMAAW",
            "ContentLocale": "en_US",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit",
                "Quality"
            ],
            "IsRatingsOnly": false,
            "TotalFeedbackCount": 0,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 0,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_174779840mMQEYp0wc",
            "SubmissionTime": "2025-05-21T03:33:47.000+00:00",
            "ReviewText": "Super comfy for everyday wear! I like mine to run a little big so a Medium was a perfect fit!",
            "Title": "Worlds best sweats",
            "UserNickname": "Areanna",
            "SecondaryRatings": {
                "Quality": {
                    "Value": 5,
                    "Id": "Quality",
                    "ValueRange": 5,
                    "MinLabel": null,
                    "ValueLabel": null,
                    "MaxLabel": null,
                    "Label": "Quality of Product",
                    "DisplayType": "NORMAL"
                },
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "Medium",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "ContextDataValues": {
                "height": {
                    "Value": "54",
                    "Id": "height",
                    "ValueLabel": "5'4\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "120lbs",
                    "Id": "weight",
                    "ValueLabel": "120 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Helpfulness": null,
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": true,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": []
        },
        {
            "Id": "290889694",
            "CID": "17937501-ec86-5d3c-860f-0dbf9525dac0",
            "SourceClient": "garageclothing",
            "LastModeratedTime": "2025-05-16T00:30:04.000+00:00",
            "LastModificationTime": "2025-05-16T00:30:04.000+00:00",
            "ProductId": "1000919207YC",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "209t68bw8plvpmqbnir0emzxw",
            "ContentLocale": "en_US",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit"
            ],
            "IsRatingsOnly": false,
            "TotalFeedbackCount": 0,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 0,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_1747354098DjHdDjyh",
            "SubmissionTime": "2025-05-16T00:07:36.000+00:00",
            "ReviewText": "Got xs I like the softness hopefully the quality is still good after first wash I’m new to buying from here so for the price I hope the quality is there",
            "Title": "Wide legs",
            "UserNickname": "gigimeme",
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "XS",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "SecondaryRatings": {
                "HowDoesItFit": {
                    "Value": 4,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "Slightly larger",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "ContextDataValues": {
                "height": {
                    "Value": "56",
                    "Id": "height",
                    "ValueLabel": "5'6\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "130lbs",
                    "Id": "weight",
                    "ValueLabel": "130 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Helpfulness": null,
            "Badges": {},
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": true,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": [],
            "BadgesOrder": []
        },
        {
            "Id": "290762814",
            "CID": "0656c9fe-cb2c-5c3b-b247-6d12519e05b6",
            "SourceClient": "garageclothing",
            "Badges": {
                "verifiedPurchaser": {
                    "ContentType": "REVIEW",
                    "Id": "verifiedPurchaser",
                    "BadgeType": "Custom"
                }
            },
            "BadgesOrder": [
                "verifiedPurchaser"
            ],
            "LastModeratedTime": "2025-05-12T23:00:06.000+00:00",
            "LastModificationTime": "2025-05-17T03:30:11.000+00:00",
            "ProductId": "10009192018X",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "003OO00000MMmpdYAD",
            "ContentLocale": "en_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit",
                "Quality"
            ],
            "IsRatingsOnly": false,
            "Helpfulness": 1.0,
            "TotalFeedbackCount": 1,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 1,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_17470891XBADyiSx3X",
            "SubmissionTime": "2025-05-12T22:32:01.000+00:00",
            "ReviewText": "super comfy and warm!!!!! have got a few others in different colours and have loved the overall wear of them!",
            "Title": "awesome sweats",
            "UserNickname": "anjanique",
            "SecondaryRatings": {
                "Quality": {
                    "Value": 5,
                    "Id": "Quality",
                    "ValueRange": 5,
                    "MinLabel": null,
                    "ValueLabel": null,
                    "MaxLabel": null,
                    "Label": "Quality of Product",
                    "DisplayType": "NORMAL"
                },
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "xxs",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "ContextDataValues": {
                "height": {
                    "Value": "51",
                    "Id": "height",
                    "ValueLabel": "5'1\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "under100",
                    "Id": "weight",
                    "ValueLabel": "Under 100 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": true,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": []
        },
        {
            "Id": "290376912",
            "CID": "5e12ce5e-ea90-5595-a581-0497d6e542ef",
            "SourceClient": "garageclothing",
            "LastModeratedTime": "2025-04-29T21:30:07.000+00:00",
            "LastModificationTime": "2025-05-18T02:47:08.000+00:00",
            "ProductId": "10009192085Q",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "height"
            ],
            "AuthorId": "5pkyttz4cpp6w4ik05dtc2miz",
            "ContentLocale": "en_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit"
            ],
            "IsRatingsOnly": false,
            "Helpfulness": 1.0,
            "TotalFeedbackCount": 15,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 15,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_17459546IkRtJt6fzI",
            "SubmissionTime": "2025-04-29T19:24:27.000+00:00",
            "ReviewText": "I made an account just to leave this review lol these sweatpants are the first to actually fit me properly. For reference I'm 5'11\" and they actually reach the floor I'm so happy. If you are tall, GET THESE!",
            "Title": "GOOD FOR TALL GIRLS!!!",
            "UserNickname": "noiraline",
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "M",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "SecondaryRatings": {
                "HowDoesItFit": {
                    "Value": 4,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "Slightly larger",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "ContextDataValues": {
                "height": {
                    "Value": "511",
                    "Id": "height",
                    "ValueLabel": "5'11\"",
                    "DimensionLabel": "Height"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Badges": {},
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": true,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": [],
            "BadgesOrder": []
        },
        {
            "Id": "290321458",
            "CID": "6816710d-6a06-5905-b579-db63fb5d0a80",
            "SourceClient": "garageclothing",
            "LastModeratedTime": "2025-04-27T15:45:08.000+00:00",
            "LastModificationTime": "2025-05-06T01:41:13.000+00:00",
            "ProductId": "10009192018X",
            "OriginalProductName": "Pantalon de jogging à jambe droite en tissu UltraFleece",
            "ContextDataValuesOrder": [
                "height"
            ],
            "AuthorId": "ldwuwygn92ysp1mnm64wh0mf8",
            "ContentLocale": "fr_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit"
            ],
            "IsRatingsOnly": false,
            "Helpfulness": 1.0,
            "TotalFeedbackCount": 1,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 1,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-fr_174571667xbMsyfWQA",
            "SubmissionTime": "2025-04-27T01:18:13.000+00:00",
            "ReviewText": "Love love love, littéralement les meilleurs jogging ever , trop confo et tellement bon esthétiquement !!!! \nLe prix équivaut avec la qualité😍 \nMeilleur jogging hands down ! ;)\nAssez long aussi pour les tall girlies.",
            "Title": "IN LOVE",
            "UserNickname": "clooo13",
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "S",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "SecondaryRatings": {
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "ContextDataValues": {
                "height": {
                    "Value": "58",
                    "Id": "height",
                    "ValueLabel": "5'8\"",
                    "DimensionLabel": "Height"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Badges": {},
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": null,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": [],
            "BadgesOrder": []
        },
        {
            "Id": "290179813",
            "CID": "c3da096a-86d8-5973-aca9-4a979cdcc450",
            "SourceClient": "garageclothing",
            "LastModeratedTime": "2025-04-22T21:30:06.000+00:00",
            "LastModificationTime": "2025-05-17T05:38:24.000+00:00",
            "ProductId": "1000919207YC",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "sjtyfx0n6z16epdj8cgawba8i",
            "ContentLocale": "en_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 3,
            "SecondaryRatingsOrder": [
                "HowDoesItFit"
            ],
            "IsRatingsOnly": false,
            "Helpfulness": 1.0,
            "TotalFeedbackCount": 8,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 8,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_17453561OHDrAoCoIW",
            "SubmissionTime": "2025-04-22T21:08:33.000+00:00",
            "ReviewText": "I don’t understand why Garage’s sweatpants are always so big and long, they literally drag on the ground. I was wearing the cargo ones and I tried rolling them up but they still bragged on the ground and got very dirty and the dirt didn’t come out, I tried cutting them but that just looked weird too. Same problem with these, not wearing them outside because they will get dirty and permanently stained easily. The XXS and the XS are the exact same size and the only sweat pants that fit fine are the boyfriend joggers with the elastic cuff at the bottom. They would be very nice sweats if not for the problems, other places have similar styles in XXS and they’re not this long.",
            "Title": "WAY TOO BIG!!!!!!!!!",
            "UserNickname": "Alison Victoria",
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "XXS",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "SecondaryRatings": {
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "ContextDataValues": {
                "height": {
                    "Value": "53",
                    "Id": "height",
                    "ValueLabel": "5'3\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "under100",
                    "Id": "weight",
                    "ValueLabel": "Under 100 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Badges": {},
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": null,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": [],
            "BadgesOrder": []
        },
        {
            "Id": "290119312",
            "CID": "26d26ef4-31ad-530b-b045-bbb131ab5b49",
            "SourceClient": "garageclothing",
            "Badges": {
                "verifiedPurchaser": {
                    "ContentType": "REVIEW",
                    "Id": "verifiedPurchaser",
                    "BadgeType": "Custom"
                }
            },
            "BadgesOrder": [
                "verifiedPurchaser"
            ],
            "LastModeratedTime": "2025-04-20T13:30:06.000+00:00",
            "LastModificationTime": "2025-04-24T00:27:33.000+00:00",
            "ProductId": "100091920",
            "OriginalProductName": "Pantalon de jogging à jambe droite en tissu UltraFleece",
            "CampaignId": "BV_PIE",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "05146025",
            "ContentLocale": "fr_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 5,
            "SecondaryRatingsOrder": [
                "HowDoesItFit",
                "Quality"
            ],
            "IsRatingsOnly": false,
            "Helpfulness": 1.0,
            "TotalFeedbackCount": 1,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 1,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-fr_174511751s9WjjIx0h",
            "SubmissionTime": "2025-04-20T02:51:50.000+00:00",
            "ReviewText": "J’ai acheter les jogging depuis moins d’un mois et je suis tres contente de les avoir pris. Il sont extrêmement confortable et tres douce et qualiter est tres bien.J’ai eu un accident avec eux et les taches sont partis facilement. Bref, je vous conseille de les acheter",
            "Title": "Qualité",
            "UserNickname": "Shhsuachh",
            "SecondaryRatings": {
                "Quality": {
                    "Value": 5,
                    "Id": "Quality",
                    "ValueRange": 5,
                    "MinLabel": null,
                    "ValueLabel": null,
                    "MaxLabel": null,
                    "Label": "Quality of Product",
                    "DisplayType": "NORMAL"
                },
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "Xs",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "ContextDataValues": {
                "height": {
                    "Value": "55",
                    "Id": "height",
                    "ValueLabel": "5'5\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "100lbs",
                    "Id": "weight",
                    "ValueLabel": "100 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": null,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": []
        },
        {
            "Id": "290088469",
            "CID": "e563218c-d8ce-5a3d-8ce6-4c37eb73d963",
            "SourceClient": "garageclothing",
            "Badges": {
                "verifiedPurchaser": {
                    "ContentType": "REVIEW",
                    "Id": "verifiedPurchaser",
                    "BadgeType": "Custom"
                }
            },
            "BadgesOrder": [
                "verifiedPurchaser"
            ],
            "LastModeratedTime": "2025-04-18T16:45:08.000+00:00",
            "LastModificationTime": "2025-05-12T04:24:49.000+00:00",
            "ProductId": "10009192018X",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "0034x00001skZHAAA2",
            "ContentLocale": "en_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Rating": 4,
            "SecondaryRatingsOrder": [
                "HowDoesItFit",
                "Quality"
            ],
            "IsRatingsOnly": false,
            "Helpfulness": 1.0,
            "TotalFeedbackCount": 2,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 2,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_17449925SYNMAcsCVX",
            "SubmissionTime": "2025-04-18T16:08:52.000+00:00",
            "ReviewText": "Good Aritzia dupes, size up for a baggier fit, super soft and comfy.",
            "Title": "A must need staple",
            "UserNickname": "smiap",
            "SecondaryRatings": {
                "Quality": {
                    "Value": 4,
                    "Id": "Quality",
                    "ValueRange": 5,
                    "MinLabel": null,
                    "ValueLabel": null,
                    "MaxLabel": null,
                    "Label": "Quality of Product",
                    "DisplayType": "NORMAL"
                },
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "Small",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "ContextDataValues": {
                "height": {
                    "Value": "51",
                    "Id": "height",
                    "ValueLabel": "5'1\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "120lbs",
                    "Id": "weight",
                    "ValueLabel": "120 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "Photos": [],
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": null,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": []
        },
        {
            "Id": "290039298",
            "CID": "a5dc39ed-2cfc-57e8-a8a8-048c5a99aeed",
            "SourceClient": "garageclothing",
            "Badges": {
                "verifiedPurchaser": {
                    "ContentType": "REVIEW",
                    "Id": "verifiedPurchaser",
                    "BadgeType": "Custom"
                }
            },
            "BadgesOrder": [
                "verifiedPurchaser"
            ],
            "LastModeratedTime": "2025-04-18T20:45:07.000+00:00",
            "LastModificationTime": "2025-04-18T20:45:07.000+00:00",
            "ProductId": "10009192085Q",
            "OriginalProductName": "UltraFleece Straight Leg Sweatpants",
            "ContextDataValuesOrder": [
                "weight",
                "height"
            ],
            "AuthorId": "0034x00001igZHEAA2",
            "ContentLocale": "en_CA",
            "IsFeatured": false,
            "TotalInappropriateFeedbackCount": 0,
            "TotalClientResponseCount": 0,
            "TotalCommentCount": 0,
            "Photos": [
                {
                    "Sizes": {
                        "normal": {
                            "Id": "normal",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/cf8a901a-d13d-56f4-b71b-d53ebdb42f28"
                        },
                        "thumbnail": {
                            "Id": "thumbnail",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/fae1f590-b12a-5019-ae66-fceec709e7a8"
                        },
                        "large": {
                            "Id": "large",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/9b0443af-9fe1-57f5-8366-51e5f6f5ed39"
                        }
                    },
                    "Id": "17445575",
                    "SizesOrder": [
                        "normal",
                        "thumbnail",
                        "large"
                    ],
                    "Caption": null
                },
                {
                    "Sizes": {
                        "normal": {
                            "Id": "normal",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/12f59c3e-f044-5576-b0f2-267ca09d902c"
                        },
                        "thumbnail": {
                            "Id": "thumbnail",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/7edb1eb1-61c7-513a-abb5-949a3a517f6e"
                        },
                        "large": {
                            "Id": "large",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/ed0ea47e-745b-598d-912a-e87af2d16ef4"
                        }
                    },
                    "Id": "17445576",
                    "SizesOrder": [
                        "normal",
                        "thumbnail",
                        "large"
                    ],
                    "Caption": null
                },
                {
                    "Sizes": {
                        "normal": {
                            "Id": "normal",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/6b3cdee7-3dc5-56f0-9514-0db680033219"
                        },
                        "thumbnail": {
                            "Id": "thumbnail",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/37d70be7-ed2f-5b39-9ad8-a359359c7534"
                        },
                        "large": {
                            "Id": "large",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/82ae284b-4d4b-537b-baf9-0cdc02148b89"
                        }
                    },
                    "Id": "17445577",
                    "SizesOrder": [
                        "normal",
                        "thumbnail",
                        "large"
                    ],
                    "Caption": null
                },
                {
                    "Sizes": {
                        "normal": {
                            "Id": "normal",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/6b3cdee7-3dc5-56f0-9514-0db680033219"
                        },
                        "thumbnail": {
                            "Id": "thumbnail",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/37d70be7-ed2f-5b39-9ad8-a359359c7534"
                        },
                        "large": {
                            "Id": "large",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/82ae284b-4d4b-537b-baf9-0cdc02148b89"
                        }
                    },
                    "Id": "17445577",
                    "SizesOrder": [
                        "normal",
                        "thumbnail",
                        "large"
                    ],
                    "Caption": null
                },
                {
                    "Sizes": {
                        "normal": {
                            "Id": "normal",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/6b3cdee7-3dc5-56f0-9514-0db680033219"
                        },
                        "thumbnail": {
                            "Id": "thumbnail",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/37d70be7-ed2f-5b39-9ad8-a359359c7534"
                        },
                        "large": {
                            "Id": "large",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/82ae284b-4d4b-537b-baf9-0cdc02148b89"
                        }
                    },
                    "Id": "17445577",
                    "SizesOrder": [
                        "normal",
                        "thumbnail",
                        "large"
                    ],
                    "Caption": null
                },
                {
                    "Sizes": {
                        "normal": {
                            "Id": "normal",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/6b3cdee7-3dc5-56f0-9514-0db680033219"
                        },
                        "thumbnail": {
                            "Id": "thumbnail",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/37d70be7-ed2f-5b39-9ad8-a359359c7534"
                        },
                        "large": {
                            "Id": "large",
                            "Url": "https://photos-us.bazaarvoice.com/photo/2/cGhvdG86Z2FyYWdlY2xvdGhpbmc/82ae284b-4d4b-537b-baf9-0cdc02148b89"
                        }
                    },
                    "Id": "17445577",
                    "SizesOrder": [
                        "normal",
                        "thumbnail",
                        "large"
                    ],
                    "Caption": null
                }
            ],
            "Rating": 3,
            "SecondaryRatingsOrder": [
                "HowDoesItFit",
                "Quality"
            ],
            "IsRatingsOnly": false,
            "TotalFeedbackCount": 0,
            "TotalNegativeFeedbackCount": 0,
            "TotalPositiveFeedbackCount": 0,
            "ModerationStatus": "APPROVED",
            "SubmissionId": "r114126-en_17448417uwW1Khx9p9",
            "SubmissionTime": "2025-04-16T22:16:27.000+00:00",
            "ReviewText": "These sweatpants are perfect, I love this colour and the oversized fit ! I’m usually in between xs/s but I sized up in these for a baggier fit. I also love the flared leg, perfect to wear with my uggs!",
            "Title": "Love this new colour!!",
            "UserNickname": "Eva Silvester",
            "SecondaryRatings": {
                "Quality": {
                    "Value": 5,
                    "Id": "Quality",
                    "ValueRange": 5,
                    "MinLabel": null,
                    "ValueLabel": null,
                    "MaxLabel": null,
                    "Label": "Quality of Product",
                    "DisplayType": "NORMAL"
                },
                "HowDoesItFit": {
                    "Value": 3,
                    "Id": "HowDoesItFit",
                    "ValueRange": 5,
                    "MinLabel": "Run Small",
                    "ValueLabel": "True to size",
                    "MaxLabel": "Run Large",
                    "Label": "How does it fit?",
                    "DisplayType": "SLIDER"
                }
            },
            "AdditionalFields": {
                "sizeOrdered": {
                    "Value": "Small",
                    "Id": "sizeOrdered",
                    "Label": "Size Ordered"
                }
            },
            "AdditionalFieldsOrder": [
                "sizeOrdered"
            ],
            "ContextDataValues": {
                "height": {
                    "Value": "57",
                    "Id": "height",
                    "ValueLabel": "5'7\"",
                    "DimensionLabel": "Height"
                },
                "weight": {
                    "Value": "100lbs",
                    "Id": "weight",
                    "ValueLabel": "100 lbs",
                    "DimensionLabel": "Aprox. Weight"
                }
            },
            "InappropriateFeedbackList": [],
            "ClientResponses": [],
            "Pros": null,
            "CampaignId": null,
            "IsSyndicated": false,
            "RatingRange": 5,
            "Helpfulness": null,
            "ProductRecommendationIds": [],
            "UserLocation": null,
            "IsRecommended": null,
            "TagDimensionsOrder": [],
            "Cons": null,
            "TagDimensions": {},
            "Videos": [],
            "CommentIds": []
        }
    ],
    "Includes": {},
    "HasErrors": false,
    "Errors": []
}

module.exports = {
    bvReviewsAPIResponse
};
